<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import { ModelSelect } from 'vue-search-select';
import $ from "jquery";
export default {
  components: { ErrorMessage, Layout, PageHeader,ModelSelect },
  data() {
    return {
      title: "Sales Manager Booking Report",
      items: [
        {
          text: "Reports",
          href: "/",
        },
        {
          text: "Sales Manager Report",
          active: true,
        },
      ],
      admins: [],
        alladmins:[],
      pin: "",
      bookings: [],
      user_id: "",
        manager_user_id:"",
      booking_startdate: "",
      booking_enddate: "",
        travel_startdate: "",
        travel_enddate: "",
        airline_pnr:"",
        booking_status:"",
        ticket_no:"",
      remarks: "",
        user_type:"",
      errors: null,
        visible:false,
        display_div:true,
        message:"",
        search1:"",
        booking_statuses:[],
        search_fname:"",
        search_lname:"",
        search_account_type:"",
        search_target_api:"",
        search_trip_type:"",
        search_api_pnr:"",
        search_airline_pnr:"",
        search_routes:"",
        search_booking_status:"",
        search_payment_status:"",
        search_total_passenger:"",
        search_ait:"",
        search_airline:"",
        search_gross_fare:"",
        search_base_fare:"",
        search_total_tax:"",
        search_invoice_fare:"",
        search_commission:"",
        search_markup:"",
    };
  },
    created() {
       this.booking_status=this.$route.params.status;
    },
  mounted() {
    this.getAdminList();
    // this.search();
  },

    methods: {
      onClose(){
          this.visible=false;
      },
        searchFilterFunc2(val) {
            this.search1=val;
        },
        toggleDiv: function() {
            this.display_div = !this.display_div;
        },
    async getAdminList() {
      try {
        axios
          .get("/api/admin/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++) {
                    temp[i].value = temp[i].id;
                    temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                    arr.push(temp[i]);
                }
                    this.admins=arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
        async getBookingStatuses() {
            try {
                axios
                    .get("/api/flight-booking/statuses", {
                        params: {
                            accessToken: localStorage.getItem("access_tocken"),
                        },
                    })
                    .then((response) => {
                        if (response.data.status) {
                            this.booking_statuses = response.data.data;
                        } else {
                            var str = response.data.message;
                            var jsonParse = JSON.parse(str);
                            this.errorCheck(jsonParse);
                        }
                    })
                    .catch((error) => {
                        console.log(error.message);
                    });
            } catch (err) {
                console.log(err);
            }
        },
    async search() {
      try {
        axios
          .get("/api/reports/manager-sales", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
              manager_user_id: this.manager_user_id,
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.bookings = response.data.data;

                setTimeout(function(){

                        $('#sales-manager-booking').DataTable(
                            {
                                pagingType: 'full_numbers',
                                pageLength: 5,
                                processing: true,
                                dom: 'Bfrtip',
                                bDestroy: true,
                                bSort : false,
                                paging:false,
                                buttons: [
                                    {
                                        extend: 'copyHtml5',
                                        exportOptions: {
                                            columns: [1, 2, 3, 4, 5, 6, 7]
                                        }
                                    },
                                    'csv',
                                    {
                                        extend: 'pdfHtml5',
                                        exportOptions: {
                                            columns: [1, 2, 3, 4, 5, 6, 7]
                                        }
                                    },
                                    {
                                        extend: 'print',
                                        footer: 'true',
                                        title: "Sales Manager Booking Report",
                                        autoPrint: 'false',
                                        customize: function (win) {
                                            $(win.document.body)
                                                .css('font-size', '6pt');

                                            $(win.document.body).find('table')
                                                .addClass('compact')
                                                .css('font-size', 'inherit');
                                        }
                                    }
                                ],
                            }
                        );
                    },
                    10
                );
                $("#sales-manager-booking").DataTable().clear().destroy();
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (obj.message !== "Token has expired") {
        this.errors = obj.message;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout @CustomEventInputChangedAll="searchFilterFunc2">
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
              <b-button class='float-right' v-if="display_div" v-on:click="toggleDiv()" size="sm">Collapse</b-button>
              <b-button class='float-right' v-else v-on:click="toggleDiv()" size="sm">Expand</b-button>
            <div v-if="display_div" class="row">
              <div class="col-md-6">
                <div class="form-group">
                    <model-select :options="admins"
                                  v-model="manager_user_id"
                                  placeholder="Select Sales Manager">
                    </model-select>
                </div>
              </div>

              <div class="col-md-6 text-center"><button class="btn btn-primary" @click.prevent="search()">Search</button></div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Booking List</h4>
            <div class="table-responsive table-responsive-sm">
              <table id="sales-manager-booking" class="table mb-0 table-striped">
                <thead>
                  <tr>
                      <th>#</th>
                      <th>Ticket Issue Date</th>
                      <th>Ticket No</th>
                      <th>Flying Date</th>
                      <th>Route</th>
                      <th>User</th>
                      <th>Pax Name</th>
                      <!--                    <th>First Name</th>-->
                      <!--                    <th>Last Name</th>-->
                      <th>Passport</th>
                      <th>Status</th>
                      <th>Ref. Key</th>
                      <th>Type</th>
                      <th>API PNR</th>
                      <th>Airline PNR</th>
                      <th>Base Fare</th>
                      <th>Tax</th>
                      <th>Gross Fare</th>
                      <th>Commission</th>
                      <th>Markup</th>
                      <th>Ait</th>
                      <th>Invoice Fare</th>
                  </tr>

                </thead>
                <tbody>
                  <tr v-for="(sale,index) in bookings"  v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                      <td v-if="sale.flight_tickets.length">{{sale.flight_tickets[0].created_at | moment('D MMM YYYY, H:mm')}}</td>
                      <td v-else>N/A</td>
                      <td v-if="sale.flight_tickets.length">{{sale.flight_tickets[0].ticket_no}}</td>
                      <td v-else>N/A</td>
                      <td>{{sale.flight_date==null ? 'N/A' : sale.flight_date | moment('D MMM YYYY, H:mm')}}</td>
                      <td>{{sale.route==null ? 'N/A' : sale.route}}</td>
                      <td v-if="sale.account_type=='b2b'">{{sale.agency_name+"("+sale.account_type+")"}}</td>
                      <td v-if="sale.account_type=='b2c'">{{sale.user.first_name+' '+sale.user.last_name+"("+sale.account_type+")"}}</td>
                      <td>
                          <div  v-for="(passeneger,index) in sale.passenger_info['name']">
                              <div class="col-xs-4">{{passeneger}}</div>
                          </div>
                      </td>
                      <td>
                          <div  v-for="(passport,index) in sale.passenger_info['passport']">
                              <div class="col-xs-4">{{passport}}</div>
                          </div>
                      </td>

<!--                      <td v-if="sale.flight_tickets.length">{{sale.flight_tickets[0].ticket_no}}</td>-->
<!--                      <td v-else>N/A</td>-->
<!--                      <td v-if="sale.flight_passengers.length">{{sale.flight_passengers[0].prefix+' '+sale.flight_passengers[0].first_name+' '+sale.flight_passengers[0].last_name}}</td>-->
<!--                      <td v-else>N/A</td>-->
                      <!--                    <td>{{sale.passenger.first_name}}</td>-->
                      <!--                    <td>{{sale.passenger.last_name}}</td>-->
<!--                      <td v-if="sale.flight_passengers.length">{{sale.flight_passengers[0].passport_no}}</td>-->
<!--                      <td v-else>N/A</td>-->
                      <td>{{sale.booking_status.status_name}}</td>
                      <td>{{sale.search_reference_key}}</td>
                      <td>{{sale.trip_type=='R'?"Round Trip":"One Way"}}</td>
                      <td>{{sale.api_pnr==null?'N/A':sale.api_pnr}}</td>
                      <td>{{sale.airline_pnr==null?'N/A':sale.airline_pnr}}</td>
                      <td>{{sale.base_fare==null?'N/A':sale.base_fare}}</td>
                      <td>{{sale.total_tax==null?'N/A':sale.total_tax}}</td>
                      <td>{{sale.gross_fare==null?'N/A':sale.gross_fare}}</td>
                      <td>{{sale.commission==null?'N/A':sale.commission}}</td>
                      <td>{{sale.markup==null?'N/A':sale.markup}}</td>
                      <td>{{sale.ait==null?'N/A':sale.ait}}</td>
                      <td>{{sale.invoice_fare==null?'N/A':sale.invoice_fare}}</td>

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.dropdown-menu.show {
    display: block;
    z-index: 10003;
}
#start-datepicker1__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker1__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#start-datepicker2__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
#end-datepicker2__dialog_{
    transform: translate3d(0px, 0px, 0px)!important;
}
.float-right{
    float: right;
}
.button-padding{
    margin-top:-6%;
}
</style>
